import { render, staticRenderFns } from "./checkReportFootFootPressure.vue?vue&type=template&id=8df1c036&scoped=true&"
import script from "./checkReportFootFootPressure.vue?vue&type=script&lang=js&"
export * from "./checkReportFootFootPressure.vue?vue&type=script&lang=js&"
import style0 from "./checkReportFootFootPressure.vue?vue&type=style&index=0&id=8df1c036&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df1c036",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8df1c036')) {
      api.createRecord('8df1c036', component.options)
    } else {
      api.reload('8df1c036', component.options)
    }
    module.hot.accept("./checkReportFootFootPressure.vue?vue&type=template&id=8df1c036&scoped=true&", function () {
      api.rerender('8df1c036', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/check/components/checkReportFootFootPressure.vue"
export default component.exports